import React, { useState, useMemo } from 'react';
import * as uuid from 'uuid';
import { DateTime } from 'luxon';
import { transformF2FSlots, groupSlotsByWeekSorted, formatDate, ConsultantSlot } from './helpers';
import { F2FSlotGrid } from '../BookAppointment/F2FSlotGrid';

const DisplayAvailableSlotsFace2Face = ({
  clinician,
  setSelectedSlot,
  setSelectedSlotInfo,
  case_id,
  appt_id,
  patientData
}: {
  clinician: ConsultantSlot;
  setSelectedSlot: (slot: any) => void;
  setSelectedSlotInfo: (slotInfo: any) => void;
  case_id: number | null;
  appt_id: number;
  patientData: any;
}) => {
  const [currentWeek, setCurrentWeek] = useState(0);

  const tranformedSlots = useMemo(() => transformF2FSlots(clinician?.slots), [clinician?.slots]);
  const slotsByWeek = useMemo(() => Object.values(groupSlotsByWeekSorted(tranformedSlots)), [tranformedSlots]);
  const currentWeekSlots = useMemo(() => slotsByWeek[currentWeek], [slotsByWeek, currentWeek]);

  const handleSelectSlot = (selectedSlot) => {
    setSelectedSlot({
      UID: uuid.v4(),
      slotId: selectedSlot?.slotId,
      gmcCode: clinician?.gmcCode,
      gmc: clinician?.gmc,
      firstName: patientData?.first_name,
      lastName: patientData?.last_name,
      dob: formatDate(new Date(patientData?.dob)),
      telephone: `+${patientData?.tel_mobile_no}`,
      addr1: patientData?.addline1,
      addr2: patientData?.addline2,
      postalCode: patientData?.postcode,
      email: patientData?.email,
      memberId: patientData?.membership_no,
      gender: patientData?.sex,
      insuranceProvider: 'AXA',
      title: patientData?.title,
      service: clinician?.service,
      clin_user_guid: clinician?.clin_user_guid,
      patient_guid: patientData?.user_guid,
      hospital_postcode: clinician?.locationData?.postcode,
      hospital_id: clinician?.locationData?.hospital_id,
      api_code: clinician.api_code,
      hospital_group: clinician?.group,
      appt_date: new Date(selectedSlot?.start),
      case_id,
      appt_id
    });
    setSelectedSlotInfo({
      clin_name: `${clinician?.title} ${clinician?.first_name} ${clinician?.last_name}`,
      time: DateTime.fromJSDate(selectedSlot?.start).setZone(patientData?.timezone).toFormat('EEE, DD, HH:mm'),
      location: `${clinician?.locationData?.name}, ${clinician?.locationData?.postcode}`
    });
  };

  return (
    <F2FSlotGrid
      clinician={clinician}
      weekCount={currentWeek}
      maxWeekCount={slotsByWeek?.length - 1}
      setWeekCount={setCurrentWeek}
      slots={currentWeekSlots}
      timezone={patientData?.timezone}
      selectSlot={handleSelectSlot}
    />
  );
};

export default DisplayAvailableSlotsFace2Face;
